import React from "react";

export const HOME_TOUR_STEPS = [
  {
    id: "home-overview",
    selector: '[data-tour-id="site-root"]',
    fullscreen: true,
    title: "Welcome to Somemas Recovery",
    description:
      "This free 22-week course helps you build self-control and hope. Track your progress and complete daily tasks week by week. Everything is saved privately on your device.",
    padding: 0,
    radius: 10,
    fitOptions: { maxHeightFraction: 1.0, maxWidthFraction: 1.0, focusFractionY: 0.5 },
    inset: 0,
  },
  {
    id: "hero-cta",
    selector: '[data-tour-id="hero-cta"]',
    title: "Start or Continue Your Journey",
    description:
      "Tap here to begin Week 1 or pick up where you left off.",
    padding: 14,
    radius: 14,
  },
  {
    id: "streak-card",
    selector: '[data-tour-id="streak-card"]',
    title: "Your Streak",
    description:
      "See how many days you’ve gone without relapsing. Start or end a streak anytime—your progress is saved locally.",
    padding: 12,
    radius: 12,
  },
  {
    id: "today-task",
    selector: '[data-tour-id="today-task"]',
    title: "Daily Task",
    description:
      "IMPORTANT: Complete one task every day by clicking the checkbox. You must do this 7 days in a row to complete a week, after which you’ll be assigned a new task. Missing a day resets the week.",
    padding: 8,
    radius: 12,
    inset: 1,
  },
  {
    id: "share-box",
    selector: '[data-tour-id="share-box"]',
    title: "Share Somemas Recovery",
    description: "Invite someone to our site. Use the Share button to copy or send the link.",
    padding: 12,
    radius: 12,
    inset: 0,
    optional: true,
  },
  {
    id: "support-card",
    selector: '[data-tour-id="support-card"]',
    title: "Support the Site",
    description: "If this website helps you, consider supporting us. Even small contributions are meaningful to us.",
    padding: 12,
    radius: 12,
    optional: true,
  },
  {
    id: "nav-home",
    selector: '[data-tour-id="nav-home"]',
    selectorMobile: '[data-tour-id="navbar-menu"]',
    title: "Navigation — Home",
    description: "Go back to the main page anytime.",
    // Desktop: slightly tighter than before
    padding: 4,
    inset: 0,
    radius: 10,
    // Mobile: keep the tight wrap around the hamburger button
    paddingMobile: 0,
    insetMobile: 2,
    optional: true,
  },
  {
    id: "nav-tracker",
    selector: '[data-tour-id="nav-tracker"]',
    selectorMobile: '[data-tour-id="navbar-menu"]',
    title: "Navigation — Tracker",
    description: "See your weekly progress at a glance.",
    padding: 0,
    paddingMobile: 0,
    inset: 2,
    radius: 10,
    optional: true,
  },
  {
    id: "nav-sponsors",
    selector: '[data-tour-id="nav-sponsors"]',
    selectorMobile: '[data-tour-id="navbar-menu"]',
    title: "Navigation — Our Sponsors",
    description: "Learn about the tools and partners that we have.",
    padding: 0,
    paddingMobile: 0,
    inset: 2,
    radius: 10,
    optional: true,
  },
  {
    id: "nav-settings",
    selector: '[data-tour-id="nav-settings"]',
    selectorMobile: '[data-tour-id="navbar-menu"]',
    title: "Navigation — Settings",
    description: "Change preferences or reset the tutorial here.",
    padding: 0,
    paddingMobile: 0,
    inset: 2,
    radius: 10,
    optional: true,
  },
  {
    id: "nav-theme",
    selector: '[data-tour-id="nav-theme"]',
    selectorMobile: '[data-tour-id="navbar-menu"]',
    title: "Dark / Light Mode",
    description: "Switch between dark and light themes to suit your preference.",
    padding: 0,
    paddingMobile: 0,
    inset: 2,
    insetMobile: 2,
    radius: 10,
    optional: true,
  },
];